import React, { ReactElement, ReactNode } from 'react';
import { Box, Card, Typography } from '@material-ui/core';

type TitledCardProps = {
  title: string;
  fullHeight?: boolean;
  children?: ReactNode | undefined;
};

export const TitledCard = ({ title, fullHeight, children }: TitledCardProps): ReactElement => {
  return (
    <Card style={{ height: fullHeight ? '100%' : undefined }}>
      <Box display="flex" flexDirection={'column'} p={2} style={{ gap: '8px' }}>
        <Box>
          {' '}
          <Typography variant="overline">{title}</Typography>{' '}
        </Box>
        <Box>{children}</Box>
      </Box>
    </Card>
  );
};
